import { useEffect, useState } from "react";
import useDataBean from "../../../../../core/services/dataBean/useDataBean";
import { Singleton } from "../../../../../core/services/Singleton";
import { _DocumentFactory, _single } from "../../../../../core/services/dataBean/EntityCatalog";
import { toast } from "react-toastify";
import { ListMenu } from "../../../../theme/Component/ListMenu";
import { BasicPage } from "../../../../theme/Component/BasicPage";
import { BasicTable } from "../../../../theme/Component/BasicTable";
import { Modal } from "../../../../theme/Component/Modal";
import { DocumentViewer } from "../../../../theme/Component/DocumentViewer";
import { ModalConfirm } from "../../../../theme/Component/ModalConfirm";
import { _TimeEventAccounting, _TimeEventCatalog } from "../../../../../core/services/dataBean/EntityCatalogVdos";
import { InputDate } from "../../../../theme/Input/InputDate";
import { SelectStoreEditor } from "../../../../contract/etapa-contrato/contrac/ublinvoice/SelectStore.editor";
import useModal, { MODAL_LG } from "../../../../theme/Component/hooks/useModal";
import { PrintJson } from "../../../../theme/Component/PrintJson";


interface Props {
    idProductionOrder: any;
    productionOrderDate: any;
}

export const TimeMovements = ({ idProductionOrder, productionOrderDate }: Props) => {

    const Timemov = useDataBean(_TimeEventCatalog);
    const CreateTimemov = useDataBean(_TimeEventAccounting);
    const single = Singleton.getInstance();
    const [docs, setDocs] = useState<any>([]);
    const [msgList, setMsgList] = useState<any>([]);
    const [docsvdos, setDocsvdos] = useState<any>([]);
    const _documentos = useDataBean(_DocumentFactory);
    const [lista, setLista] = useState<any>([]);
    const [appoGroup, setAppoGroup] = useState<number>(null)
    const [modalcontabletime, setModalcontabletime] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalverdoc, setModalverdoc] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalverdocvdos, setModalverdocvdos] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modal, setModal] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalC, setModalC] = useState<any>({ name: "Eliminar", tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });
    const modaldoccreate = useModal("Contabilizar Tiempos y Movimientos", MODAL_LG);
    useEffect(() => {
        getLista();
    }, [idProductionOrder, productionOrderDate])
    useEffect(() => {
        if (modalverdoc.view) {
            verDocumentos();
        }
    }, [modalverdoc.view]);
    const getLista = () => {

        Timemov.instance.getTimeEventCatalog(idProductionOrder, productionOrderDate).then(
            (resp: any) => {
                if (resp) {
                    let x = resp;
                    x.forEach((user) => {

                        user.DataBeanProperties.Doc = (user.DataBeanProperties.Mnemonic ?? "") + "-" + (user.DataBeanProperties.Consecutive ?? "") + "-" + (user.DataBeanProperties.DocumentDate ?? "");

                    });
                    setLista(x)
                }
            }
        )

    }


    const create = () => {
        Timemov.setBean({

        });
        setModal({ ...modal, "view": true });
    }
    const deleteItem = () => {
        Timemov.deleteItemVoid(Timemov.bean).then(
            (resp: any) => {
                getLista();
                setModalC({ ...modalC, "view": false });
            }
        )

    }
    const editaItem = () => {
        //console.log(entailment.bean);
        Timemov.update().then(
            (resp: any) => {
                getLista();
                setModal({ ...modal, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })

    }

    const head = [
        { title: 'ID', property: 'IDTimeEvent', visible: true },
        { title: 'Actividad/Operación', property: 'LabourName', visible: true },
        { title: 'Cantidad Producida', property: 'LabourQuantity', visible: true },
        { title: 'Cantidad Tiempo', property: 'TimeUnits', visible: true },
        { title: 'Unidades Medida', property: 'LabourTimeUnitName', visible: true },
        { title: 'Empleado en Línea de Producción', property: 'ProductionEmployeeName', visible: true },
        { title: 'Turno', property: 'IDWorkTurn', visible: true },
        { title: 'Fecha Turno', property: 'WorkTurnDate', visible: true },
        { title: 'Documento', property: 'Doc', visible: true },
    ]
    const verDocumentos = () => {

        if (Timemov.bean) {
            _documentos.instance.getPdfAccountantDocument(Timemov.bean.IDDocument, null, Timemov.bean.DocumentDate, _single.getAccountID()).then(
                (resp: any) => {
                    console.log(resp);
                    setDocs(resp.DocumentURL);
                    setModalverdoc({ ...modalverdoc, "view": true });
                }
            )
        } else {
            toast.warning("No hay documento asociado");
        }

    }
    const iconButtonsItem = [
        { nombre: 'Agregar', visible: single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]
    const listaBotones = () => {
        const botones = [
            { titulo: 'Ver Documento', icono: 'ri-edit-2-line', visible: single.canEdit(), evento: () => { setModalverdoc({ ...modalverdoc, "view": true }) } },
            { titulo: 'Contabilizar Tiempos y Movimientos', icono: 'ri-edit-2-line', visible: single.canEdit(), evento: () => { setModalcontabletime({ ...modalcontabletime, "view": true }) } },


        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }

    const createTimeEventAccountingForProductionOrder = () => {
        CreateTimemov.instance.createTimeEventAccountingForProductionOrder(Timemov.bean.IDTimeEvent, CreateTimemov.bean.AccountantDate, CreateTimemov.bean.Description, _single.getAccountID()).then(
            (resp: any) => {
                if (resp) {
                    toast.success('Contabilizado')
                    setDocsvdos(resp.DocumentURL);
                    setModalcontabletime({ ...modalcontabletime, "view": false });
                    setModalverdocvdos({ ...modalverdocvdos, "view": true });
                    setMsgList(resp.MsgList);

                    // ✅ Mostrar cada mensaje del backend en un toast
                    resp.MsgList?.forEach((msg: string) => {
                        toast.info(msg);
                    });
                }
            }
        ).catch(
            err => {
                toast.error(err)
            }
        )
    }

    return (
        <BasicPage titulo="Tiempos y Movimientos">
            <div className="row">
                <div className="col-md-12">
                    <BasicTable body={lista} head={head} rowSet={Timemov.setBean} listButtons={listaBotones()} ></BasicTable>
                    <Modal modal={modal} updateModal={setModal} >
                        <div className="row">

                            <div className="col-md-6">
                                <label>Código</label>
                                <input type="text" name="Code" className="form-control" value={Timemov.bean.Code} onChange={Timemov.handleChange} />
                            </div>
                            <div className="col-md-6">
                                <label>Nombre</label>
                                <input type="text" name="Name" className="form-control" value={Timemov.bean.Name} onChange={Timemov.handleChange} />
                                {/* <SelectFunctionalID renderValue="" onChange={()=>{}}/> */}
                            </div>
                        </div>
                    </Modal>
                    <Modal modal={modalverdoc} updateModal={setModalverdoc}>
                        <div className="row">

                            <DocumentViewer
                                list={docs}
                                IDDocument={Timemov.bean.IDDocument}
                                Since={Timemov.bean.DocumentDate}
                            />
                        </div>
                    </Modal>

                    <Modal modal={modalcontabletime} updateModal={setModalcontabletime} eventModal={createTimeEventAccountingForProductionOrder} onSubmitLabel="Contabilizar">
                        <div className="row">
                            <div className="col-md-12">
                                <InputDate name="AccountantDate" value={CreateTimemov.bean.AccountantDate} label="Fecha de Contabilización" setDate={(e) => { CreateTimemov.setBean({ ...CreateTimemov.bean, "AccountantDate": e }) }} />
                            </div>
                            <div className="col-md-12">
                                <label>Descripción</label>
                                <textarea name="Description" className="form-control" value={CreateTimemov.bean.Description} onChange={(e) => { CreateTimemov.setBean({ ...CreateTimemov.bean, 'Description': e.target.value }) }} />
                            </div>
                        </div>
                    </Modal>
                    <Modal modal={modalverdocvdos} updateModal={setModalverdocvdos}>
                        <div className="row">
                            <PrintJson json={msgList} />
                            <DocumentViewer
                                list={docsvdos}
                            />
                        </div>
                    </Modal>
                    <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteItem}>
                        <strong>Eliminar item {Timemov.bean.Name}</strong>
                    </ModalConfirm>
                </div>

            </div>
        </BasicPage>
    )
}